import dayjs from "dayjs"
import buddhistEra from 'dayjs/plugin/buddhistEra';
import { fullMonthNames, shortMonthNames } from "../../common/data/monthName"

export const ConvertDate = (date=new Date()) => {
    dayjs.locale("th")
    const convertOBJ = {
        toDateISO: () => {
            const dateConvert = new Date(date)
            return `${dateConvert?.getFullYear()}-${('0' + (dateConvert?.getMonth()+1))?.slice(-2)}-${('0' + dateConvert?.getDate())?.slice(-2)}T00:00:00.000Z`
            // return `${dateConvert?.getFullYear()}-${('0' + (dateConvert?.getMonth()+1))?.slice(-2)}-${('0' + dateConvert?.getDate())?.slice(-2)}T${('0' + dateConvert?.getHours())?.slice(-2)}:${('0' + dateConvert?.getMinutes())?.slice(-2)}:${('0' + dateConvert?.getSeconds())?.slice(-2)}.000Z`
        },
        toOnlyDateISO: () => {
            const dateConvert = new Date(date)
            return `${dateConvert?.getFullYear()}-${('0' + (dateConvert?.getMonth()+1))?.slice(-2)}-${('0' + dateConvert?.getDate())?.slice(-2)}`
            // return `${dateConvert?.getFullYear()}-${('0' + (dateConvert?.getMonth()+1))?.slice(-2)}-${('0' + dateConvert?.getDate())?.slice(-2)}T${('0' + dateConvert?.getHours())?.slice(-2)}:${('0' + dateConvert?.getMinutes())?.slice(-2)}:${('0' + dateConvert?.getSeconds())?.slice(-2)}.000Z`
        },
        toOnlyDate: () => {
            const dateConvert = new Date(date)
            return `${dateConvert?.getFullYear()}-${('0' + (dateConvert?.getMonth()+1))?.slice(-2)}-${('0' + dateConvert?.getDate())?.slice(-2)}`
        },
        toThaiDateDMY: () => {
            const dateConvert = new Date(date)
            return `${('0' + dateConvert?.getDate())?.slice(-2)} ${shortMonthNames[(dateConvert?.getMonth())]} ${dateConvert?.getFullYear()+543}`
        },
        toThaiDateFullDMY: () => {
            const dateConvert = new Date(date)
            return `${('0' + dateConvert?.getDate())?.slice(-2)} ${fullMonthNames[(dateConvert?.getMonth())]} ${dateConvert?.getFullYear()+543}`
        },

        toFullFormat: () => {
            const dateConvert = new Date(date)
            return `${('0' + dateConvert?.getDate())?.slice(-2)}/${('0' + (dateConvert?.getMonth()+1))?.slice(-2)}/${dateConvert?.getFullYear()+543} ${('0' + dateConvert.getHours()).slice(-2)}:${('0' + dateConvert.getMinutes()).slice(-2)}`
        },
        toTimeHMS: () => {
            const dateConvert = new Date(date)
            return `${('0' + dateConvert?.getHours())?.slice(-2)}:${('0' + dateConvert?.getMinutes())?.slice(-2)}:${('0' + dateConvert?.getSeconds())?.slice(-2)}`
        },
        toHHmmTime: () => {
            // const dateConvert = new Date(date)
            // return `${('0' + dateConvert.getHours()).slice(-2)}:${('0' + dateConvert.getMinutes()).slice(-2)}`
            return dayjs.utc(date).format("HH:mm")
        },
        toOnlyDateTHYear: () => {
            const dateConvert = new Date(date)
            return `${('0' + dateConvert?.getDate())?.slice(-2)}/${('0' + (dateConvert?.getMonth()+1))?.slice(-2)}/${dateConvert?.getFullYear()+543}`
        },

        toFullDateISO: () => {
            const dateConvert = date
            return `${dateConvert?.getFullYear()}-${('0' + (dateConvert?.getMonth() + 1))?.slice(-2)}-${('0' + dateConvert?.getDate())?.slice(-2)}T${('0' + dateConvert?.getHours())?.slice(-2)}:${('0' + dateConvert?.getMinutes())?.slice(-2)}:00.000Z`;
        },//cant'convert
    }
    return convertOBJ
}

export function generateDateArray(dateStart, dateEnd) {
    const startDate = new Date(dateStart);
    const endDate = new Date(dateEnd);
    const dateArray = [];

    while (startDate <= endDate) {
        dateArray.push(new Date(startDate));
        startDate.setDate(startDate.getDate() + 1);
    }

    return dateArray;
}

export const convertDateRange = (dateRange) => {
    const monthNamesThai = [
        "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", 
        "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", 
        "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"
    ];

    let [startDate, endDate] = dateRange.split(" - ");

    const convertDate = (dateStr) => {
        let [day, month, year] = dateStr.split("/").map(Number);
        year += 543;
        return `${day} ${monthNamesThai[month - 1]} ${year}`;
    }

    let startDateThai = convertDate(startDate);
    let endDateThai = convertDate(endDate);

    return `${startDateThai} - ${endDateThai}`;
}



export const getDateTime = (format = 'YYYY-MM-DD', textDate = null, minus7 = false) => {
    dayjs.locale('th');
    dayjs.extend(buddhistEra);
    let dateTime = textDate ? new Date(textDate) : new Date();
    return dayjs(dateTime).add(minus7 ? -7 : 0, 'hour').format(format);
  };